var map = {
	"./androidQrCode.png": "vWYu",
	"./banner0.png": "V8MZ",
	"./banner1.png": "CMrX",
	"./bg_company_no.png": "l5Tq",
	"./bg_discount.png": "IEWN",
	"./bg_discount_no.png": "pFpo",
	"./bg_discount_red.png": "6UTj",
	"./bg_discount_white.png": "bZT2",
	"./bg_goodsDetail.png": "p0LS",
	"./bg_img_add.png": "WoDw",
	"./bg_index_time_btn.png": "/HuI",
	"./bg_index_time_limit.png": "1lkw",
	"./bg_index_time_limit1.png": "vLD1",
	"./bg_index_time_limit2.png": "1QkD",
	"./bg_index_time_limit3.png": "V0it",
	"./bg_index_time_limit4.png": "pFJ5",
	"./bg_index_time_limit5.png": "DyJY",
	"./bg_industry.png": "y5Nw",
	"./bg_jurisdiction.png": "Bs6Q",
	"./bg_login.png": "m30q",
	"./bg_login2.jpg": "TbmS",
	"./bg_num.png": "BakZ",
	"./bg_sales.png": "597f",
	"./bg_sales_detail.png": "DmNC",
	"./bg_search_no.png": "5qGs",
	"./building.png": "guhP",
	"./ca.png": "3Gg2",
	"./couponsSelected.png": "peyJ",
	"./defaultpcbg.png": "+lkR",
	"./dot.png": "ZB7i",
	"./favicon.ico": "IymD",
	"./icon_add_img.png": "ZKfm",
	"./icon_address.png": "+Pvt",
	"./icon_address_select.png": "/8yL",
	"./icon_apply.png": "SMK9",
	"./icon_car.png": "nbeZ",
	"./icon_certify.png": "OMnL",
	"./icon_change.png": "/qPa",
	"./icon_check_normal.png": "tjZG",
	"./icon_check_pressed.png": "gq9g",
	"./icon_close.png": "ShLw",
	"./icon_close_img.png": "vhDh",
	"./icon_collect.png": "0CrL",
	"./icon_delete.png": "gCVN",
	"./icon_edit.png": "U6G2",
	"./icon_explain.png": "BEgR",
	"./icon_fail.png": "icHJ",
	"./icon_first.png": "islR",
	"./icon_footer1.png": "bClb",
	"./icon_footer2.png": "AYAj",
	"./icon_footer3.png": "i17b",
	"./icon_footer4.png": "QhnD",
	"./icon_goods_attention.png": "YnIW",
	"./icon_goods_attention_full.png": "gr+l",
	"./icon_goods_car.png": "GAIz",
	"./icon_goods_contrast.png": "vgvC",
	"./icon_goods_show_list_normal.png": "tPYD",
	"./icon_goods_show_list_ressed.png": "UbY9",
	"./icon_goods_show_normal.png": "wl1T",
	"./icon_goods_show_ressed.png": "5TM3",
	"./icon_goods_type.png": "CMaN",
	"./icon_goods_type_active.png": "M3+C",
	"./icon_head_active.png": "Ku1F",
	"./icon_head_car.png": "VDsk",
	"./icon_head_search.png": "XWVq",
	"./icon_index_right.png": "lCao",
	"./icon_industry.png": "EEbw",
	"./icon_information_new.png": "Ege0",
	"./icon_issue_success.png": "cLTU",
	"./icon_jurisdiction_close.png": "v3J1",
	"./icon_jurisdiction_open.png": "+51c",
	"./icon_login_code.png": "3Zv5",
	"./icon_login_password.png": "mvNS",
	"./icon_login_phone.png": "ltL2",
	"./icon_logo_white.png": "3ow4",
	"./icon_money.png": "3iC0",
	"./icon_more.png": "mYqV",
	"./icon_more_active.png": "ClOY",
	"./icon_more_top.png": "XaaJ",
	"./icon_nav1.png": "5OJ3",
	"./icon_nav10.png": "iQxl",
	"./icon_nav2.png": "Bj9+",
	"./icon_nav3.png": "AbrR",
	"./icon_nav4.png": "DqxA",
	"./icon_nav5.png": "7Th6",
	"./icon_nav6.png": "k1mu",
	"./icon_nav7.png": "Br0I",
	"./icon_nav8.png": "XDO/",
	"./icon_nav9.png": "HJSm",
	"./icon_nav_ classify.png": "nwRu",
	"./icon_need.png": "uYhM",
	"./icon_news1.png": "b1oN",
	"./icon_news2.png": "JmQP",
	"./icon_news3.png": "f74v",
	"./icon_order1.png": "IlKD",
	"./icon_order2.png": "VnTO",
	"./icon_order3.png": "NbjM",
	"./icon_order4.png": "L74S",
	"./icon_order5.png": "d1jF",
	"./icon_order6.png": "UbzW",
	"./icon_order7.png": "Vu2S",
	"./icon_pay_way1.png": "dpcy",
	"./icon_pay_way2.png": "qwwS",
	"./icon_pay_way3.png": "L8aS",
	"./icon_pay_way4.png": "WRe/",
	"./icon_pay_way5.png": "easr",
	"./icon_pay_way6.png": "Ok1k",
	"./icon_placeholder_normal.png": "tYAW",
	"./icon_result_success.png": "KD9/",
	"./icon_right_white.png": "BXnZ",
	"./icon_sanjiao.png": "JAKa",
	"./icon_search.png": "3rhe",
	"./icon_second.png": "YpgN",
	"./icon_select.png": "uGxc",
	"./icon_select_active.png": "uSgg",
	"./icon_sift.png": "FkqE",
	"./icon_sift_bottom.png": "yOXv",
	"./icon_sift_normal.png": "VhwP",
	"./icon_sift_top.png": "nSTp",
	"./icon_staff.png": "d8Ns",
	"./icon_star_normal.png": "c5AN",
	"./icon_star_ressed.png": "AwnD",
	"./icon_success.png": "JsnA",
	"./icon_third.png": "eVpz",
	"./icon_time.png": "v35C",
	"./icon_to_more.png": "wXVC",
	"./icon_vip0.png": "Lj76",
	"./icon_vip1.png": "Hdag",
	"./icon_vip2.png": "+FKa",
	"./icon_vip3.png": "tPMi",
	"./kefu.png": "KGy/",
	"./logo.png": "iQH9",
	"./mobile/account.png": "bF3g",
	"./mobile/add_to_purchase_order.png": "7cgS",
	"./mobile/address.png": "fUxI",
	"./mobile/address_bottom_line.png": "m/dC",
	"./mobile/address_chosen.png": "y7Sk",
	"./mobile/address_empty.png": "8Kyu",
	"./mobile/ask_bg.png": "3vI9",
	"./mobile/back.png": "+O9w",
	"./mobile/bg_discount_no.png": "QrwD",
	"./mobile/bill.png": "frkF",
	"./mobile/brand.png": "gACX",
	"./mobile/brand_icon.png": "lW/q",
	"./mobile/caigou.png": "NfpV",
	"./mobile/cart.png": "JI+V",
	"./mobile/cart_active.png": "09Ht",
	"./mobile/cart_empty.png": "+93s",
	"./mobile/cart_icon.png": "oXUO",
	"./mobile/case.png": "PJXY",
	"./mobile/category.png": "+jvN",
	"./mobile/category_active.png": "dqrK",
	"./mobile/combination.png": "zyVG",
	"./mobile/combination_tc.png": "ixXu",
	"./mobile/compare.png": "qR4V",
	"./mobile/compare_check_chose.png": "jr7T",
	"./mobile/compare_check_normal.png": "j59n",
	"./mobile/complete.png": "v8n7",
	"./mobile/coupon_bg.png": "e0md",
	"./mobile/delete_icon.png": "s/IE",
	"./mobile/edit_icon.png": "egLk",
	"./mobile/error.png": "Dwgo",
	"./mobile/fav.png": "R4ij",
	"./mobile/fav_bg.png": "tJqy",
	"./mobile/finance.png": "d2N7",
	"./mobile/group.png": "vc67",
	"./mobile/groupon_tc.png": "1PYF",
	"./mobile/history.png": "/pJg",
	"./mobile/home.png": "2buq",
	"./mobile/home_active.png": "JtYa",
	"./mobile/icon_car.png": "QdAR",
	"./mobile/icon_check_normal.png": "0lhm",
	"./mobile/icon_check_pressed.png": "uZAx",
	"./mobile/icon_close_img.png": "j6Da",
	"./mobile/icon_delete.png": "+iEB",
	"./mobile/icon_news1.png": "Yi+C",
	"./mobile/icon_news2.png": "a+L9",
	"./mobile/icon_news3.png": "ZThC",
	"./mobile/icon_placeholder_normal.png": "n827",
	"./mobile/icon_sift_bottom.png": "hgjE",
	"./mobile/icon_sift_normal.png": "ssxo",
	"./mobile/icon_sift_top.png": "wHm8",
	"./mobile/index_ad.png": "CVDb",
	"./mobile/index_ad_cw.png": "KtwS",
	"./mobile/index_ad_hd.jpg": "vOHI",
	"./mobile/index_ad_hd_old.png": "j5do",
	"./mobile/index_ad_mys.png": "dd1n",
	"./mobile/integralMall.png": "mUVs",
	"./mobile/invoice.png": "TAjv",
	"./mobile/kefu.png": "6dvO",
	"./mobile/list_change0.png": "VdVL",
	"./mobile/list_change1.png": "hj1g",
	"./mobile/mine.png": "UN5s",
	"./mobile/mine_active.png": "oC38",
	"./mobile/more.png": "hM/W",
	"./mobile/needs.png": "hf2D",
	"./mobile/negotiate_no.png": "ByCN",
	"./mobile/news.png": "d9uo",
	"./mobile/news_word.png": "yXJE",
	"./mobile/part_pay.png": "NLWh",
	"./mobile/pre_sale.png": "/5cV",
	"./mobile/presale_tc.png": "rhAb",
	"./mobile/pro.png": "LY0b",
	"./mobile/promotion.png": "Jna1",
	"./mobile/promotion_bg.png": "OHyB",
	"./mobile/promotion_tc.png": "06Te",
	"./mobile/protect.png": "4UJq",
	"./mobile/save.png": "MBS0",
	"./mobile/search.png": "ldgE",
	"./mobile/search_empty.png": "DetN",
	"./mobile/seckill.png": "si7+",
	"./mobile/seckill_icon.png": "YEGu",
	"./mobile/seckill_tc.png": "AWAO",
	"./mobile/select.png": "OlPc",
	"./mobile/switch.png": "AUx6",
	"./mobile/title.png": "mBrL",
	"./mobile/un_fav.png": "ec8K",
	"./mobile/upload_images.png": "RxVu",
	"./mobile/upload_voucher.png": "Jfql",
	"./mobile/wait_confirm.png": "/tAg",
	"./mobile/wait_delivery.png": "p/O7",
	"./mobile/wait_pay.png": "h+XE",
	"./mobile/wait_take_delivery.png": "n8/t",
	"./mobile/weixin.png": "u7AJ",
	"./mobile/分类/brand1.png": "SCAc",
	"./mobile/分类/brand2.png": "A4Ic",
	"./mobile/分类/分类图片1@2x.png": "5mkQ",
	"./mobile/分类/分类图片1@3x.png": "AMMb",
	"./mobile/分类/分类图片2@2x.png": "HujT",
	"./mobile/分类/分类图片2@3x.png": "/f0g",
	"./mobile/分类/分类图片3@2x.png": "OCgx",
	"./mobile/分类/分类图片3@3x.png": "+Fvf",
	"./mobile/分类/切换经过@2x.png": "GE/U",
	"./mobile/分类/切换经过@3x.png": "wnBp",
	"./mobile/分类/切换经过拷贝@2x.png": "OaKQ",
	"./mobile/分类/切换经过拷贝@3x.png": "RVaz",
	"./mobile/分类/提问icon@2x.png": "iWMk",
	"./mobile/分类/提问icon@3x.png": "u1/e",
	"./mobile/分类/提问背景@2x.png": "QVmD",
	"./mobile/分类/提问背景@3x.png": "vqNB",
	"./mobile/分类/比价@2x.png": "ooPB",
	"./mobile/分类/比价@3x.png": "DH/B",
	"./mobile/分类/组23@2x.png": "XbZy",
	"./mobile/分类/组23@3x.png": "K04R",
	"./mobile/分类/组24@2x.png": "YDJn",
	"./mobile/分类/组24@3x.png": "4Ruk",
	"./mobile/底部/01首页默认icon@2x.png": "sSHG",
	"./mobile/底部/02首页选中icon@2x.png": "dcLt",
	"./mobile/底部/03分类默认icon@2x.png": "cBO0",
	"./mobile/底部/04分类选中icon@2x.png": "OpgJ",
	"./mobile/底部/05购物车默认icon@2x.png": "q5X8",
	"./mobile/底部/06购物车选中icon@2x.png": "aCWU",
	"./mobile/底部/09我的默认icon@2x.png": "o1Q4",
	"./mobile/底部/10我的选择icon@2x.png": "YESo",
	"./mobile/底部/cart.png": "orpu",
	"./mobile/底部/cart_active.png": "/KpA",
	"./mobile/底部/category.png": "csGj",
	"./mobile/底部/category_active.png": "/AUC",
	"./mobile/底部/home.png": "GlO9",
	"./mobile/底部/home_active.png": "Q6gm",
	"./mobile/底部/mine.png": "x6Un",
	"./mobile/底部/mine_active.png": "NnqX",
	"./mobile/底部/图层3@2x.png": "UM06",
	"./mobile/底部/图层3@3x.png": "sBWE",
	"./mobile/底部/返回icon@2x.png": "TUN9",
	"./mobile/底部/返回icon@3x.png": "Y1yb",
	"./mobile/登录注册/勾-已选@2x.png": "/yu1",
	"./mobile/登录注册/勾-已选@3x.png": "QHto",
	"./mobile/登录注册/勾-默认@2x.png": "3Qs5",
	"./mobile/登录注册/勾-默认@3x.png": "mtzq",
	"./mobile/登录注册/微信icon@2x.png": "14n0",
	"./mobile/登录注册/微信icon@3x.png": "gThG",
	"./mobile/登录注册/成功@2x.png": "D5mv",
	"./mobile/登录注册/成功@3x.png": "Xh2v",
	"./mobile/登录注册/登录界面切换icon@2x.png": "DxfK",
	"./mobile/登录注册/登录界面切换icon@3x.png": "HeWH",
	"./mobile/登录注册/返回@2x.png": "N8yt",
	"./mobile/登录注册/返回@3x.png": "zFw9",
	"./mobile/购物车/下载@2x.png": "+lqB",
	"./mobile/购物车/下载@3x.png": "aFR/",
	"./mobile/购物车/优惠券@2x.png": "Eq6H",
	"./mobile/购物车/优惠券@3x.png": "L2EC",
	"./mobile/购物车/优惠券背景@2x.png": "ACIR",
	"./mobile/购物车/优惠券背景@3x.png": "VUSd",
	"./mobile/购物车/删除红色@2x.png": "uogl",
	"./mobile/购物车/删除红色@3x.png": "Qc5t",
	"./mobile/购物车/喜欢标题@2x.png": "fZJR",
	"./mobile/购物车/喜欢标题@3x.png": "T/GN",
	"./mobile/购物车/圆角矩形1@2x.png": "4mB4",
	"./mobile/购物车/圆角矩形1@3x.png": "3Hpu",
	"./mobile/购物车/圆角矩形2@2x.png": "kz3Q",
	"./mobile/购物车/圆角矩形2@3x.png": "O9Tz",
	"./mobile/购物车/地址横线@2x.png": "8/Vu",
	"./mobile/购物车/地址横线@3x.png": "hhew",
	"./mobile/购物车/微信@2x.png": "BhZI",
	"./mobile/购物车/微信@3x.png": "TBEH",
	"./mobile/购物车/成功icon@2x@2x.png": "LcBa",
	"./mobile/购物车/成功icon@2x@3x.png": "6JAm",
	"./mobile/购物车/支付1@2x.png": "SuG5",
	"./mobile/购物车/支付1@3x.png": "Gr7e",
	"./mobile/购物车/支付2@2x.png": "GBn+",
	"./mobile/购物车/支付2@3x.png": "gLSM",
	"./mobile/购物车/支付3@2x.png": "V4TA",
	"./mobile/购物车/支付3@3x.png": "Wt5O",
	"./mobile/购物车/支付4@2x.png": "6/G8",
	"./mobile/购物车/支付4@3x.png": "EJ/H",
	"./mobile/购物车/支付5@2x.png": "PQZH",
	"./mobile/购物车/支付5@3x.png": "FOIr",
	"./mobile/购物车/数量@2x.png": "DCap",
	"./mobile/购物车/数量@3x.png": "jkGj",
	"./mobile/购物车/暂无配送地址icon@2x@2x.png": "dmG2",
	"./mobile/购物车/暂无配送地址icon@2x@3x.png": "HOzu",
	"./mobile/购物车/更多拷贝@2x.png": "4Rku",
	"./mobile/购物车/更多拷贝@3x.png": "z0IH",
	"./mobile/购物车/未上传@2x.png": "iPou",
	"./mobile/购物车/未上传@3x.png": "K+mT",
	"./mobile/购物车/标题竖线@2x.png": "lk0l",
	"./mobile/购物车/标题竖线@3x.png": "OE+y",
	"./mobile/购物车/汇款@2x.png": "mBb6",
	"./mobile/购物车/汇款@3x.png": "+IKM",
	"./mobile/购物车/汇票@2x.png": "O88W",
	"./mobile/购物车/汇票@3x.png": "0vFP",
	"./mobile/购物车/编辑icon@2x.png": "YQpb",
	"./mobile/购物车/编辑icon@3x.png": "Le8u",
	"./mobile/购物车/购物车暂无icon@2x@2x.png": "jD2I",
	"./mobile/购物车/购物车暂无icon@2x@3x.png": "aEx5",
	"./mobile/购物车/选择@2x.png": "QDOY",
	"./mobile/购物车/选择@3x.png": "No7s",
	"./mobile/首页/产品图2@2x.png": "viY3",
	"./mobile/首页/产品图2@3x.png": "TJ+i",
	"./mobile/首页/产品图@2x.png": "H+2M",
	"./mobile/首页/产品图@3x.png": "VVFP",
	"./mobile/首页/从低到高@2x - 副本.png": "mGBV",
	"./mobile/首页/从低到高@2x.png": "4J6T",
	"./mobile/首页/从低到高@3x.png": "FuO6",
	"./mobile/首页/从高到低@2x - 副本.png": "nsd8",
	"./mobile/首页/从高到低@2x.png": "T6EP",
	"./mobile/首页/从高到低@3x.png": "30Xa",
	"./mobile/首页/供应链金融/dianhua的副本@2x.png": "1Jg4",
	"./mobile/首页/供应链金融/dianhua的副本@3x.png": "7xKH",
	"./mobile/首页/供应链金融/不挑@2x.png": "aaW3",
	"./mobile/首页/供应链金融/不挑@3x.png": "sZTS",
	"./mobile/首页/供应链金融/个性化@2x.png": "jloi",
	"./mobile/首页/供应链金融/个性化@3x.png": "1L0L",
	"./mobile/首页/供应链金融/便利@2x.png": "0GJ6",
	"./mobile/首页/供应链金融/便利@3x.png": "g3r8",
	"./mobile/首页/供应链金融/信用@2x.png": "+kle",
	"./mobile/首页/供应链金融/信用@3x.png": "gN1S",
	"./mobile/首页/供应链金融/公平@2x.png": "W5LJ",
	"./mobile/首页/供应链金融/公平@3x.png": "ybjX",
	"./mobile/首页/供应链金融/关闭icon@2x.png": "W5/h",
	"./mobile/首页/供应链金融/关闭icon@3x.png": "4HaM",
	"./mobile/首页/供应链金融/创建icon@2x.png": "k1sM",
	"./mobile/首页/供应链金融/创建icon@3x.png": "AQJo",
	"./mobile/首页/供应链金融/利率低@2x.png": "yKJW",
	"./mobile/首页/供应链金融/利率低@3x.png": "Pu/l",
	"./mobile/首页/供应链金融/加入icon@2x.png": "8ZY7",
	"./mobile/首页/供应链金融/加入icon@3x.png": "gplB",
	"./mobile/首页/供应链金融/在线@2x.png": "EJgA",
	"./mobile/首页/供应链金融/在线@3x.png": "VoyU",
	"./mobile/首页/供应链金融/存@2x.png": "ku9C",
	"./mobile/首页/供应链金融/存@3x.png": "kA0A",
	"./mobile/首页/供应链金融/成本低@2x.png": "ow03",
	"./mobile/首页/供应链金融/成本低@3x.png": "7W1Y",
	"./mobile/首页/供应链金融/服务佳@2x.png": "/XkE",
	"./mobile/首页/供应链金融/服务佳@3x.png": "+C1i",
	"./mobile/首页/供应链金融/标题icon2@2x.png": "GxnW",
	"./mobile/首页/供应链金融/标题icon2@3x.png": "4vmZ",
	"./mobile/首页/供应链金融/标题背景@2x.png": "BNKV",
	"./mobile/首页/供应链金融/标题背景@3x.png": "J639",
	"./mobile/首页/供应链金融/申请快@2x.png": "hGon",
	"./mobile/首页/供应链金融/申请快@3x.png": "yzsz",
	"./mobile/首页/供应链金融/省费用@2x.png": "UAM6",
	"./mobile/首页/供应链金融/省费用@3x.png": "1/49",
	"./mobile/首页/供应链金融/票@2x.png": "9VnB",
	"./mobile/首页/供应链金融/票@3x.png": "i75D",
	"./mobile/首页/供应链金融/自主@2x.png": "59Ld",
	"./mobile/首页/供应链金融/自主@3x.png": "Z874",
	"./mobile/首页/供应链金融/订@2x.png": "i4xM",
	"./mobile/首页/供应链金融/订@3x.png": "ae/5",
	"./mobile/首页/供应链金融/赠利@2x.png": "V1Ic",
	"./mobile/首页/供应链金融/赠利@3x.png": "Q3RX",
	"./mobile/首页/供应链金融/通@2x.png": "OGzO",
	"./mobile/首页/供应链金融/通@3x.png": "bIie",
	"./mobile/首页/供应链金融/金融背景@2x.png": "oqn0",
	"./mobile/首页/供应链金融/金融背景@3x.png": "cDbW",
	"./mobile/首页/供应链金融/随采@2x.png": "dJn9",
	"./mobile/首页/供应链金融/随采@3x.png": "kCe9",
	"./mobile/首页/供应链金融/项目优@2x.png": "Oe+K",
	"./mobile/首页/供应链金融/项目优@3x.png": "kEDp",
	"./mobile/首页/供应链金融/额度高@2x.png": "fIHl",
	"./mobile/首页/供应链金融/额度高@3x.png": "LNUG",
	"./mobile/首页/促销优惠@2x.png": "ASA2",
	"./mobile/首页/促销优惠@3x.png": "4LTQ",
	"./mobile/首页/促销优惠icon@2x.png": "GPdN",
	"./mobile/首页/促销优惠icon@3x.png": "5QH1",
	"./mobile/首页/促销背景@2x.png": "dA5V",
	"./mobile/首页/促销背景@3x.png": "Jsfm",
	"./mobile/首页/切换选中@2x.png": "Pcck",
	"./mobile/首页/切换选中@3x.png": "cb0a",
	"./mobile/首页/切换默认@2x.png": "jqI5",
	"./mobile/首页/切换默认@3x.png": "rrUE",
	"./mobile/首页/列表切换2@2x.png": "dJMl",
	"./mobile/首页/列表切换2@3x.png": "AT1C",
	"./mobile/首页/列表切换@2x.png": "Mpc2",
	"./mobile/首页/列表切换@3x.png": "D5/4",
	"./mobile/首页/删除@2x.png": "AYYm",
	"./mobile/首页/删除@3x.png": "zEoo",
	"./mobile/首页/加入采购单@2x.png": "GNUn",
	"./mobile/首页/加入采购单@3x.png": "ajpU",
	"./mobile/首页/右@2x.png": "PGtf",
	"./mobile/首页/右@3x.png": "hw/r",
	"./mobile/首页/向上icon@2x.png": "mHUc",
	"./mobile/首页/向上icon@3x.png": "NOoY",
	"./mobile/首页/品牌@2x.png": "87LN",
	"./mobile/首页/品牌@3x.png": "1RIK",
	"./mobile/首页/品牌banner.png": "32Zm",
	"./mobile/首页/品牌icon@2x.png": "Vy6l",
	"./mobile/首页/品牌icon@3x.png": "2jJq",
	"./mobile/首页/品牌logo2@2x.png": "6kps",
	"./mobile/首页/品牌logo2@3x.png": "zfzt",
	"./mobile/首页/品牌logo3@2x.png": "UL3C",
	"./mobile/首页/品牌logo3@3x.png": "39N4",
	"./mobile/首页/品牌logo@2x.png": "axjR",
	"./mobile/首页/品牌logo@3x.png": "DC1O",
	"./mobile/首页/商品详情@2x.png": "sgAE",
	"./mobile/首页/商品详情@3x.png": "5x5O",
	"./mobile/首页/商品轮播图@2x.png": "cQgM",
	"./mobile/首页/商品轮播图@3x.png": "+zMF",
	"./mobile/首页/图层1.png": "o5bz",
	"./mobile/首页/图层101.png": "1WQ9",
	"./mobile/首页/图层2.png": "9zfP",
	"./mobile/首页/地址icon@2x.png": "A3gm",
	"./mobile/首页/地址icon@3x.png": "//YU",
	"./mobile/首页/头盔.png": "Hqr5",
	"./mobile/首页/客服icon@2x.png": "BQ7K",
	"./mobile/首页/客服icon@3x.png": "Bn08",
	"./mobile/首页/左@2x.png": "YKBX",
	"./mobile/首页/左@3x.png": "Axb3",
	"./mobile/首页/搜索@2x.png": "JYYG",
	"./mobile/首页/搜索@3x.png": "wVVI",
	"./mobile/首页/搜索暂无icon@2x@2x.png": "xInG",
	"./mobile/首页/搜索暂无icon@2x@3x.png": "F2ZU",
	"./mobile/首页/收藏-已点@2x.png": "7aUp",
	"./mobile/首页/收藏-已点@3x.png": "o231",
	"./mobile/首页/收藏-默认@2x.png": "tIZY",
	"./mobile/首页/收藏-默认@3x.png": "xA0S",
	"./mobile/首页/新建文件夹/品牌banner.png": "SNpL",
	"./mobile/首页/新建文件夹/图层101.png": "tIDB",
	"./mobile/首页/新建文件夹/头盔.png": "B/J8",
	"./mobile/首页/新建文件夹/资讯.png": "Y0UR",
	"./mobile/首页/新建文件夹/首页banner.png": "Nk0r",
	"./mobile/首页/新建文件夹/首页banner2.png": "i97G",
	"./mobile/首页/方案背景@2x.png": "oagD",
	"./mobile/首页/方案背景@3x.png": "XJp3",
	"./mobile/首页/更多icon@2x.png": "m9Q4",
	"./mobile/首页/更多icon@3x.png": "4uZw",
	"./mobile/首页/未选中@2x.png": "aYC8",
	"./mobile/首页/未选中@3x.png": "kee4",
	"./mobile/首页/标题icon2@2x.png": "xRXG",
	"./mobile/首页/标题icon2@3x.png": "HCf3",
	"./mobile/首页/标题icon@2x.png": "X9pR",
	"./mobile/首页/标题icon@3x.png": "OYwj",
	"./mobile/首页/活动/促销@2x.png": "ZTjb",
	"./mobile/首页/活动/促销@3x.png": "QN1Y",
	"./mobile/首页/活动/团购@2x.png": "ljZo",
	"./mobile/首页/活动/团购@3x.png": "Zcju",
	"./mobile/首页/活动/秒杀@2x.png": "bU02",
	"./mobile/首页/活动/秒杀@3x.png": "cUgx",
	"./mobile/首页/活动/组合@2x.png": "1wN/",
	"./mobile/首页/活动/组合@3x.png": "6AJ7",
	"./mobile/首页/活动/预售@2x.png": "0/pl",
	"./mobile/首页/活动/预售@3x.png": "LrRM",
	"./mobile/首页/海报@2x.png": "qs9W",
	"./mobile/首页/海报@3x.png": "9gxp",
	"./mobile/首页/消息/xiaoxi2@2x.png": "JfE7",
	"./mobile/首页/消息/xiaoxi2@3x.png": "Sgni",
	"./mobile/首页/消息/消息1@2x.png": "9tDt",
	"./mobile/首页/消息/消息1@3x.png": "aURt",
	"./mobile/首页/消息/消息3@2x.png": "9D6W",
	"./mobile/首页/消息/消息3@3x.png": "EUQC",
	"./mobile/首页/消息@2x.png": "gjKr",
	"./mobile/首页/消息@3x.png": "TDdO",
	"./mobile/首页/渐变背景@2x.png": "EaN8",
	"./mobile/首页/渐变背景@3x.png": "meSJ",
	"./mobile/首页/积分商城@2x.png": "1j6m",
	"./mobile/首页/积分商城@3x.png": "qNUP",
	"./mobile/首页/筛选@2x.png": "WQ/x",
	"./mobile/首页/筛选@3x.png": "FSRl",
	"./mobile/首页/筛选更多@2x.png": "JPoN",
	"./mobile/首页/筛选更多@3x.png": "+yHk",
	"./mobile/首页/箭头@2x.png": "65Ry",
	"./mobile/首页/箭头@3x.png": "vrQ2",
	"./mobile/首页/组6拷贝4@2x.png": "RABn",
	"./mobile/首页/组6拷贝4@3x.png": "wQyJ",
	"./mobile/首页/解决方案@2x.png": "3j+Z",
	"./mobile/首页/解决方案@3x.png": "AYgy",
	"./mobile/首页/购物车icon@2x.png": "c7jr",
	"./mobile/首页/购物车icon@3x.png": "F58S",
	"./mobile/首页/资讯.png": "JUuV",
	"./mobile/首页/资讯1@2x.png": "VrzN",
	"./mobile/首页/资讯1@3x.png": "bMFm",
	"./mobile/首页/资讯@2x.png": "5NPx",
	"./mobile/首页/资讯@3x.png": "2r52",
	"./mobile/首页/资讯图标/1@2x.png": "bbsA",
	"./mobile/首页/资讯图标/1@3x.png": "o7e7",
	"./mobile/首页/资讯图标/2@2x.png": "TRSU",
	"./mobile/首页/资讯图标/2@3x.png": "sGnQ",
	"./mobile/首页/资讯图标/3@2x.png": "uYMd",
	"./mobile/首页/资讯图标/3@3x.png": "bVL6",
	"./mobile/首页/资讯图标/4@2x.png": "5Sfh",
	"./mobile/首页/资讯图标/4@3x.png": "4GHN",
	"./mobile/首页/资讯图标/5@2x.png": "koTe",
	"./mobile/首页/资讯图标/5@3x.png": "8exO",
	"./mobile/首页/资讯图标/6@2x.png": "/gBR",
	"./mobile/首页/资讯图标/6@3x.png": "TICP",
	"./mobile/首页/资讯海报@2x.png": "GIcs",
	"./mobile/首页/资讯海报@3x.png": "l4Zr",
	"./mobile/首页/返回icon拷贝@2x.png": "AHHZ",
	"./mobile/首页/返回icon拷贝@3x.png": "kE06",
	"./mobile/首页/选中icon@2x.png": "rfxD",
	"./mobile/首页/选中icon@3x.png": "Cg3X",
	"./mobile/首页/金融@2x.png": "M2GG",
	"./mobile/首页/金融@3x.png": "20RP",
	"./mobile/首页/降价@2x.png": "Hdw0",
	"./mobile/首页/降价@3x.png": "0iE+",
	"./mobile/首页/限时秒杀@2x.png": "vZRo",
	"./mobile/首页/限时秒杀@3x.png": "8Zx3",
	"./mobile/首页/首页banner.png": "VDbG",
	"./mobile/首页/首页banner2.png": "qI+b",
	"./mps.gov.png": "MXqa",
	"./negotiate_no.png": "dZIp",
	"./pc-login.png": "U2yX",
	"./post.jpg": "2d+x",
	"./post2.jpg": "AlH4",
	"./post3.jpg": "eWZr",
	"./post3.png": "Z9Zh",
	"./post3_tiny.jpg": "yPHR",
	"./protect.png": "rMCR",
	"./qq.png": "CPDY",
	"./qr-code.png": "GYVL",
	"./qrIcon.png": "be8/",
	"./qrcode_toggle.png": "UHBi",
	"./replaceImg.jpg": "tij3",
	"./star.png": "FHDy",
	"./star_2.png": "gHEC",
	"./supplier1.png": "D3gz",
	"./supplier2.png": "57X6",
	"./supplier3.png": "YLDS",
	"./supplier4.png": "c77p",
	"./supplier5.png": "LnVj",
	"./tacitlyAvatra.png": "fmHO",
	"./team_add.png": "xjUP",
	"./timeStatus1.png": "dTYB",
	"./timeStatus2.png": "x4zr",
	"./timeStatus3.png": "dQ2S",
	"./tiny_icon.png": "8mVE",
	"./v.png": "Q5tc",
	"./watermark.png": "cGQ5",
	"./wx.png": "ZDm/",
	"./yishixiao.png": "yO2R",
	"./三角红色.png": "OnIa",
	"./下拉.png": "JqiX",
	"./日历.png": "n2zc",
	"./日期筛选.png": "d6Qj",
	"./银行.png": "ULBs",
	"./银行卡无.png": "QzgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 192